const EnumStateProvinces = [
  {
    EnumStateProvince: 1,
    StateProvinceName: "Alberta",
    StateProvinceCode: "AB",
    CountryRegionId: 124,
  },
  {
    EnumStateProvince: 2,
    StateProvinceName: "British Columbia",
    StateProvinceCode: "BC",
    CountryRegionId: 124,
  },
  {
    EnumStateProvince: 3,
    StateProvinceName: "Nunavut",
    StateProvinceCode: "NU",
    CountryRegionId: 124,
  },
  {
    EnumStateProvince: 4,
    StateProvinceName: "Manitoba",
    StateProvinceCode: "MB",
    CountryRegionId: 124,
  },
  {
    EnumStateProvince: 5,
    StateProvinceName: "NewBrunswick",
    StateProvinceCode: "NB",
    CountryRegionId: 124,
  },
  {
    EnumStateProvince: 6,
    StateProvinceName: "Newfoundland",
    StateProvinceCode: "NL",
    CountryRegionId: 124,
  },
  {
    EnumStateProvince: 7,
    StateProvinceName: "NovaScotia",
    StateProvinceCode: "NS",
    CountryRegionId: 124,
  },
  {
    EnumStateProvince: 8,
    StateProvinceName: "NorthwestTerritories",
    StateProvinceCode: "NT",
    CountryRegionId: 124,
  },
  {
    EnumStateProvince: 9,
    StateProvinceName: "Ontario",
    StateProvinceCode: "ON",
    CountryRegionId: 124,
  },
  {
    EnumStateProvince: 10,
    StateProvinceName: "PrinceEdwardIsland",
    StateProvinceCode: "PE",
    CountryRegionId: 124,
  },
  {
    EnumStateProvince: 11,
    StateProvinceName: "Quebec",
    StateProvinceCode: "QC",
    CountryRegionId: 124,
  },
  {
    EnumStateProvince: 12,
    StateProvinceName: "Saskatchewan",
    StateProvinceCode: "SK",
    CountryRegionId: 124,
  },
  {
    EnumStateProvince: 13,
    StateProvinceName: "YukonTerritory",
    StateProvinceCode: "YT",
    CountryRegionId: 124,
  },
  {
    EnumStateProvince: 14,
    StateProvinceName: "Alabama",
    StateProvinceCode: "AL",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 15,
    StateProvinceName: "Alaska",
    StateProvinceCode: "AK",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 16,
    StateProvinceName: "Arizona",
    StateProvinceCode: "AZ",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 17,
    StateProvinceName: "Arkansas",
    StateProvinceCode: "AR",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 18,
    StateProvinceName: "California",
    StateProvinceCode: "CA",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 19,
    StateProvinceName: "Colorado",
    StateProvinceCode: "CO",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 20,
    StateProvinceName: "Connecticut",
    StateProvinceCode: "CT",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 21,
    StateProvinceName: "Delaware",
    StateProvinceCode: "DE",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 22,
    StateProvinceName: "Florida",
    StateProvinceCode: "FL",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 23,
    StateProvinceName: "Georgia",
    StateProvinceCode: "GA",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 24,
    StateProvinceName: "Hawaii",
    StateProvinceCode: "HI",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 25,
    StateProvinceName: "Idaho",
    StateProvinceCode: "ID",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 26,
    StateProvinceName: "Illinois",
    StateProvinceCode: "IL",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 27,
    StateProvinceName: "Indiana",
    StateProvinceCode: "IN",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 28,
    StateProvinceName: "Iowa",
    StateProvinceCode: "IA",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 29,
    StateProvinceName: "Kansas",
    StateProvinceCode: "KS",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 30,
    StateProvinceName: "Kentucky",
    StateProvinceCode: "KY",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 31,
    StateProvinceName: "Louisiana",
    StateProvinceCode: "LA",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 32,
    StateProvinceName: "Maine",
    StateProvinceCode: "ME",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 33,
    StateProvinceName: "Maryland",
    StateProvinceCode: "MD",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 34,
    StateProvinceName: "Massachusetts",
    StateProvinceCode: "MA",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 35,
    StateProvinceName: "Michigan",
    StateProvinceCode: "MI",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 36,
    StateProvinceName: "Minnesota",
    StateProvinceCode: "MN",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 37,
    StateProvinceName: "Mississippi",
    StateProvinceCode: "MS",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 38,
    StateProvinceName: "Missouri",
    StateProvinceCode: "MO",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 39,
    StateProvinceName: "Montana",
    StateProvinceCode: "MT",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 40,
    StateProvinceName: "Nebraska",
    StateProvinceCode: "NE",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 41,
    StateProvinceName: "Nevada",
    StateProvinceCode: "NV",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 42,
    StateProvinceName: "NewHampshire",
    StateProvinceCode: "NH",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 43,
    StateProvinceName: "NewJersey",
    StateProvinceCode: "NJ",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 44,
    StateProvinceName: "NewMexico",
    StateProvinceCode: "NM",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 45,
    StateProvinceName: "NewYork",
    StateProvinceCode: "NY",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 46,
    StateProvinceName: "NorthCarolina",
    StateProvinceCode: "NC",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 47,
    StateProvinceName: "NorthDakota",
    StateProvinceCode: "ND",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 48,
    StateProvinceName: "Ohio",
    StateProvinceCode: "OH",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 49,
    StateProvinceName: "Oklahoma",
    StateProvinceCode: "OK",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 50,
    StateProvinceName: "Oregon",
    StateProvinceCode: "OR",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 51,
    StateProvinceName: "Pennsylvania",
    StateProvinceCode: "PA",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 52,
    StateProvinceName: "RhodeIsland",
    StateProvinceCode: "RI",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 53,
    StateProvinceName: "SouthCarolina",
    StateProvinceCode: "SC",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 54,
    StateProvinceName: "SouthDakota",
    StateProvinceCode: "SD",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 55,
    StateProvinceName: "Tennessee",
    StateProvinceCode: "TN",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 56,
    StateProvinceName: "Texas",
    StateProvinceCode: "TX",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 57,
    StateProvinceName: "Utah",
    StateProvinceCode: "UT",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 58,
    StateProvinceName: "Vermont",
    StateProvinceCode: "VT",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 59,
    StateProvinceName: "Virginia",
    StateProvinceCode: "VA",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 60,
    StateProvinceName: "Washington",
    StateProvinceCode: "WA",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 61,
    StateProvinceName: "West Virginia",
    StateProvinceCode: "WV",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 62,
    StateProvinceName: "Wisconsin",
    StateProvinceCode: "WI",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 63,
    StateProvinceName: "Wyoming",
    StateProvinceCode: "WY",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 64,
    StateProvinceName: "AmericanSamoa",
    StateProvinceCode: "AS",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 65,
    StateProvinceName: "DistrictofColumbia",
    StateProvinceCode: "DC",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 66,
    StateProvinceName: "FederatedStatesofMicronesia",
    StateProvinceCode: "FM",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 67,
    StateProvinceName: "Guam",
    StateProvinceCode: "GU",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 68,
    StateProvinceName: "NorthernMarianaIslands",
    StateProvinceCode: "MP",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 69,
    StateProvinceName: "Palau",
    StateProvinceCode: "PW",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 70,
    StateProvinceName: "PuertoRico",
    StateProvinceCode: "PR",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 71,
    StateProvinceName: "RepublicoftheMarshallIslands",
    StateProvinceCode: "MH",
    CountryRegionId: 840,
  },
  {
    EnumStateProvince: 72,
    StateProvinceName: "USVirginIslands",
    StateProvinceCode: "VI",
    CountryRegionId: 840,
  },
];

export default EnumStateProvinces;